exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".case-detail-title[data-v-6326c7dd]{font-weight:bolder;font-size:20px;color:#2d8cf0;margin-bottom:24px}.case-detail-form-item[data-v-6326c7dd]{width:44%;display:inline-block;padding-right:2%;height:40px;line-height:40px;font-size:20px}.case-detail-form-item-address[data-v-6326c7dd]{width:90%;display:inline-block;padding-right:2%;height:40px;line-height:40px;font-size:20px}.case-detail-clear[data-v-6326c7dd]{clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6326c7dd","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--1-1!./src/components/case/caseManager/caseDetail/Patient.vue
// module id = vh+N
// module chunks = 2